import React, { useState, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  subjectListAllQuery,
  subjectRemoveMutation,
} from '../../shared/queries/Subject';

const Subject = (props) => {
  const { t, dispatch, history } = props;

  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadData = () => {
    showLoading();
    const dataQuery = subjectListAllQuery();
    GraphQL(dataQuery, {})
      .then((res) => {
        let subjectList = res.subjectListAll;
        subjectList = subjectList.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(subjectList);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/disciplina/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    history.push(`/minime/disciplina/mnt/${rowData.id}`);
  };

  const removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeQuery = subjectRemoveMutation(selectedDto.id);
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        loadData();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    onRefreshClick={loadData}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    title={t('panels.disciplina')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Subject.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Subject)
);
